// Состояние стопов текущего филиала для баджа сайдбара и страницы Стоп-листа:
// stopCount - количество блюд на индивидуальном стопе, filialStop - активный
// полный стоп филиала ({stoppedAt, reason, reasonComment} | null).
// Realtime - событие Menu\StopListStateChanged в канале filial.{id}.
import StopListDataService from '@/services/api/StopListDataService'
import { websocketService } from '@/services/WebsocketService'
import { getFilialChannel } from '@/util/websocket-channels'

const STOP_LIST_STATE_EVENT = 'Menu\\StopListStateChanged'

const state = {
  stopCount: 0,
  filialStop: null,
  subscribedFilialId: null,
}

const getters = {
  getStopCount (state) {
    return state.stopCount
  },

  getFilialStop (state) {
    return state.filialStop
  },
}

const mutations = {
  setStatus (state, { stopCount, filialStop }) {
    state.stopCount = stopCount || 0
    state.filialStop = filialStop || null
  },

  setSubscribedFilialId (state, filialId) {
    state.subscribedFilialId = filialId
  },
}

const actions = {
  fetchStatus ({ commit, rootGetters }) {
    const filialId = rootGetters['branches/getGlobalFilialId']
    if (!filialId) {
      return Promise.resolve()
    }

    return StopListDataService.getStatus(filialId)
      .then((data) => commit('setStatus', data))
      // Бадж не критичен - страница должна жить и без него
      .catch((err) => console.warn('stopList/fetchStatus failed', err))
  },

  applyWsPayload ({ commit, rootGetters }, payload) {
    // События чужого филиала игнорируем: после смены филиала в шапке
    // старая подписка может дожить до переподписки
    if (!payload || payload.filialId !== rootGetters['branches/getGlobalFilialId']) {
      return
    }

    commit('setStatus', payload)
  },

  subscribe ({ state, commit, dispatch, rootGetters }) {
    const filialId = rootGetters['branches/getGlobalFilialId']
    if (!filialId || state.subscribedFilialId === filialId) {
      return
    }

    if (state.subscribedFilialId) {
      websocketService.stopListening(
        getFilialChannel(state.subscribedFilialId),
        STOP_LIST_STATE_EVENT,
      )
    }

    websocketService.listenEvent(
      getFilialChannel(filialId),
      STOP_LIST_STATE_EVENT,
      (payload) => dispatch('applyWsPayload', payload),
    )

    commit('setSubscribedFilialId', filialId)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
